export const isMyBusinessToolsHost = () =>
  window.location.hostname.includes("my-business-tools");

export const isDevHost = () => window.location.hostname.includes(".dev.");

export const getAvaLoginUrl = () =>
  isDevHost()
    ? "https://login.dev.avahealthgroup.com"
    : "https://login.avahealthgroup.com";
